import { render } from "./PolicyObject.vue?vue&type=template&id=506e3547"
import script from "./PolicyObject.vue?vue&type=script&lang=js"
export * from "./PolicyObject.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__